import { http } from "@/lib/http";
import { useToast } from "@/providers/toast.provider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateOrderInput } from "./use-create-order";

export function useUpdateOrder() {
  const queryClient = useQueryClient();
  const { toaster } = useToast();

  return useMutation({
    mutationFn: async ({ id, ...data }: CreateOrderInput & { id: string }) => {
      const res = await http.patch(`/orders/${id}`, data);
      return res.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sale", "me"] });
    },

    onError: (error) => {
      toaster(error?.message ?? "Algo deu errado!", "error");
    },
  });
}
